import type { TranslationCatalog } from "../TranslationManager";

export const uk: TranslationCatalog = {
  "labels.cardNumber": "Номер картки",
  "labels.expirationDate": "Термін дії",
  "labels.cvc": "Код безпеки",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "ММ / РР",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Номер вашої картки недійсний.",
  "errors.invalidExpiryDate": "Термін дії вашої картки недійсний.",
  "errors.invalidCvc": "Код безпеки вашої картки недійсний.",
  "errors.incompleteCardNumber": "Номер вашої картки неповний.",
  "errors.incompleteExpiryDate": "Термін дії вашої картки неповний.",
  "errors.incompleteCvc": "Код безпеки вашої картки неповний.",
  "errors.expiredCard": "Термін дії вашої картки закінчився.",
  "aria.cardNumber": "Номер картки",
  "aria.expirationDate": "Термін дії",
  "aria.cvc": "Код безпеки",
  "aria.cardInput": "Дані картки",
};
